import { render, staticRenderFns } from "./QaBoxRanking.vue?vue&type=template&id=62f7c43b&scoped=true&"
import script from "./QaBoxRanking.vue?vue&type=script&lang=js&"
export * from "./QaBoxRanking.vue?vue&type=script&lang=js&"
import style0 from "./QaBoxRanking.vue?vue&type=style&index=0&id=62f7c43b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7c43b",
  null
  
)

export default component.exports